<template>
    <!--  TODO: Start Admin Dashboard-->
    <Breadcrumb :crumbs="breadcrumbs"/>

    <div class="row card rounded-4">
        <div class="d-flex justify-content-between p-3">
            <div class="p-2">
                <h2 class="fw-bold text-success">{{$t("Prayer Times in")}} {{city}}</h2>
            </div>
            <div class="p-2 text-right text-success">
                <p>{{ englishDate }}</p>
                <p class="fw-bold">{{lang == 'bn' ? dateFormatBn : dateFormat }}</p>
            </div>
        </div>
        <div class="row card-body p-4 g-1">
            <div class="col-lg-2 col-md-2 col-sm-6" v-for="key in prayersKeys" :key="key">
                <div class="card text-center p-2"
                     :style="{
                               backgroundColor: key === upcomingPrayer ? 'transparent' : '#f2f2f2',
                               // backgroundImage: key === upcomingPrayer ? 'url(https://www.islamicfinder.org/static/live188/themes/theme20/images/maghrib.png)' : 'none',
                                backgroundImage: getBackgroundImage(key, upcomingPrayer),
                               backgroundSize: key === upcomingPrayer ? 'cover' : 'initial',
                               backgroundRepeat: key === upcomingPrayer ? 'no-repeat' : 'initial',
                               height: key === upcomingPrayer ? '180px' : '130px',
                               width: key === upcomingPrayer ? '180px' : '130px',
                               color: key === upcomingPrayer ? 'white' : 'black',
                               display: 'flex',
                               flexDirection: 'column',
                               justifyContent: 'center',
                               alignItems: 'center',
                               borderRadius: '8px',
                               margin: 'auto',
                             }">

                    <h5 :class="key === upcomingPrayer ? 'text-white' : 'text-dark'"
                            class="fw-bold">
                        {{ $t(`prayers.${key}`) }}
                    </h5>

                    <!-- If it *is* upcoming, show "Upcoming Prayers" -->
                    <template v-if="key === upcomingPrayer">
                        <h5 class="fw-bold text-white">
                            {{ $t('labels.upcomingPrayers') }}
                        </h5>
                        <h3 class="text-white">{{ timeUntilNext }}</h3>
                    </template>

                    <!-- Always show the time itself -->
                    <p class="fw-bold" :class="key === upcomingPrayer ? 'text-white' : 'text-dark'">
                        {{ prayersData[key] }}
                    </p>
                </div>
            </div>
        </div>
        <div class="p-4">
            <p>{{$t("University Of Islamic")}}</p>
            <p>{{$t("Fajr 18.0 degrees")}}
                <span><font-awesome-icon icon="circle-question"/></span></p>
        </div>
    </div>
    <div style="" v-if="isAdmin">
        <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 mt-3 activity-time">
                <div class="card p-3">
                    <div class="row">
                        <b-col class="col-md-8">
                            <h6>{{$t("All Users Activity")}}</h6>
                        </b-col>
                        <b-col class="col-md-4">
                            <b-form-select
                                    id="filter_data"
                                    v-model="filter"
                                    :options="filterOptions"
                                    field-text="filter.text"
                                    field-value="filter.value"
                                    @change="adminUserActivities"
                            >

                            </b-form-select>
                        </b-col>
                        <b-col class="col-lg-12 col-md-12 col-sm-12">
                            <div id="allUser-activity-chart" ref="chartContainer"
                                 style="width: 100%; height: 200px;"></div>
                        </b-col>

                    </div>
                </div>
            </div>
            <div class="col-md-6 mt-3 activity-time">
                <div class="card p-3" style="height: 265px">
                    <div class="row mt-2">
                        <b-col class="col-md-4 text-center">
                            <h6 class="fs-4">{{ getDayAndMonth() }}</h6>
                        </b-col>
                        <b-col class="col-md-4 text-center">
                            <h6 class="fs-4">{{ getDayName() }}</h6>
                        </b-col>
                        <b-col class="col-md-4 text-center">
                            <span class="fs-4">{{ getYear() }}</span>
                        </b-col>
                        <b-col class="col-md-4 text-center mt-3">
                            <h6 class="text-info">{{$t("Total User")}}</h6>
                            <span class="fs-2 text-success">{{ totalUserData.totalUser }}</span>
                        </b-col>
                        <b-col class="col-md-4 text-center">
                            <div class="vl"></div>
                        </b-col>
                        <b-col class="col-md-4 text-center mt-3">
                            <h6 class="text-info me-3">{{$t("Today Joined")}}</h6>
                            <span class="fs-2 text-success">{{ totalUserData.todayJoin }}</span>
                        </b-col>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 mt-3 unread-message">
                <div class="card p-3">
                    <div class="row" style="font-family: 'sans-serif'">
                        <b-col class="col-md-9">
                            <h6>{{$t("Unread Messages/Queries")}}</h6>
                        </b-col>
                        <b-col class="col-md-3">
                            <h6 style="text-decoration: none">
                                <router-link class="text-dark" style="text-decoration: none" to="/admin/all-messages">
                                    {{ $t("View All") }}
                                </router-link>
                                <font-awesome-icon icon="chevron-right" style="font-size: 12px; color: #000000"/>
                            </h6>
                        </b-col>
                        <b-col
                                class="col-md-12"
                                v-for="message in messageAll.slice(0, 5)"
                                :key="message.id"
                        >
                            <h4>
                                <font-awesome-icon icon="comment-dots" style="font-size: 16px"/>
                                {{ message.name }}
                            </h4>
                            <div>
                                <p style="font-size: 16px; color: darkgray;" class="ms-5">{{ message.email }}</p>
                                <p class="ms-5">{{ message.message }}</p>
                            </div>
                        </b-col>
                    </div>
                </div>
            </div>

            <div class="col-md-6">
                <div class="row mt-3">
                    <div class="col-md-12" style="background: #DAE9EA; padding: 10px; border: 2px solid #ffffff; border-radius: 20px">
                        <div class="row">
                            <!-- First row: Dropdowns -->
                            <b-col md="6" sm="12" class="mb-3">
                                <div class="card p-3 h-100 bg-success text-white">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <b-form-select
                                                id="filter_data"
                                                v-model="newUserData"
                                                :options="newUserOption"
                                                field-text="filter.text"
                                                field-value="filter.value"
                                                @change="handleNewUserChange"
                                        ></b-form-select>
                                    </div>
                                </div>
                            </b-col>

                            <b-col md="6" sm="12" class="mb-3">
                                <div class="card p-3 h-100 bg-success text-white">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <b-form-select
                                                id="filter_data"
                                                v-model="retention"
                                                :options="retentionType"
                                                field-text="filter.text"
                                                field-value="filter.value"
                                                @change="handleRetentionChange"

                                        ></b-form-select>
                                    </div>
                                </div>
                            </b-col>

                            <!-- Second row: First two metrics -->
                            <b-col md="6" sm="12" class="mb-3">
                                <div class="p-3 text-start h-100" style="height: 180px; border: 2px solid #fff; border-radius: 5px">
                                    <h6 class="m-0">{{$t("New Users")}}</h6>
                                    <h4 class="font-weight-bold text-center mt-3">{{ newUserOptionData }}</h4>
                                </div>
                            </b-col>

                            <!-- Third row: Retention and Total Wills -->
                            <b-col md="6" sm="12" class="mb-3">
                                <div class="p-3 text-start h-100" style="height: 180px; border: 2px solid #fff; border-radius: 5px">
                                    <h6 class="m-0">{{$t("Retention Rate")}}</h6>
                                    <h4 class="font-weight-bold text-center mt-3">{{ returningUserData.RetentionRatePercentage ?? 0 }}%</h4>
                                    <ul class="mt-2">
                                        <li>{{$t("Percentage of users returning to use the platform")}}</li>
                                    </ul>
                                </div>
                            </b-col>

                            <b-col md="6" sm="12" class="mb-3">
                                <div class="p-3 text-start h-100" style="height: 180px; border: 2px solid #fff; border-radius: 5px">
                                    <h6 class="m-0">{{$t("Abandoned Processes")}}</h6>
                                    <h4 class="font-weight-bold text-center mt-3">{{returningUserData.AbandonedUserCount}}</h4>
                                </div>
                            </b-col>

                            <b-col md="6" sm="12" class="mb-3">
                                <div class="p-3 text-start h-100" style="height: 180px; border: 2px solid #fff; border-radius: 5px">
                                    <h6 class="m-0">{{$t("Total Wills")}}</h6>
                                    <h4 class="font-weight-bold text-center mt-3">{{ returningUserData.TotalUserCount ?? 0 }}</h4>
                                </div>
                            </b-col>
                        </div>

                    </div>


                    <b-col class="col-md-12 mt-3">
                        <div class="card p-3 position-relative"
                             style="height: 255px; border: 2px solid #ffffff; border-radius: 20px"
                             id="geographical-data">
                            <div class="row align-items-center">
                                <!-- Left Column -->
                                <b-col class="col-md-4 col-12 text-center mb-3 mb-md-0">
                                    <h6 class="text-dark">{{$t("Geographical Data")}}</h6>
                                    <ul class="list-unstyled">
                                        <li>{{$t("Total Signup")}}: <strong>12,040</strong></li>
                                        <li>{{$t("Total Active Users")}}: <strong>14,140</strong></li>
                                        <li>{{$t("Abandoned Process")}}: <strong>240</strong></li>
                                    </ul>
                                </b-col>

                                <!-- Vertical Divider -->
                                <b-col class="col-md-4 col-12 d-none d-md-block">
                                    <div class="vl"></div>
                                </b-col>
                                <!-- Right Column -->
                                <b-col class="col-md-4 col-12 text-center">
                                    <b-form-select
                                            v-model="countryData"
                                            :options="countryOptions"
                                            placeholder="Select Birth Place"
                                            value-field="countryId"
                                            text-field="country"
                                            class="form-control countryData">
                                        <option value="" selected>-- {{$t("Select Country")}} --</option>
                                    </b-form-select>
                                    <ul class="list-unstyled">
                                        <li>{{$t("Total Phone Users")}}: <strong>15,200</strong></li>
                                        <li>{{$t("Total Web Users")}}: <strong>2,000</strong></li>
                                        <li>{{$t("Retention Rate")}}: <strong>40%</strong></li>
                                    </ul>
                                </b-col>
                            </div>
                        </div>
                    </b-col>
                </div>
            </div>
        </div>
    </div>
    <!--  TODO: End Admin Dashboard-->

    <!--  TODO: Start User Dashboard-->
    <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12 mt-3 activity-time">
            <div class="card p-3">
                <div class="row">
                    <b-col class="col-md-8">
                        <h6>{{$t("Users Activity")}}</h6>
                    </b-col>
                    <b-col class="col-md-4">
                        <b-form-select
                                id="filter_data"
                                v-model="filterUser"
                                :options="filterOptionsUser"
                                field-text="filter.text"
                                field-value="filter.value"
                                @change="getUserActivitiesData"
                        >

                        </b-form-select>
                    </b-col>
                    <b-col class="col-lg-12 col-md-12 col-sm-12">
                        <div id="user-activity-chart" ref="chartUserContainer"
                             style="width: 100%; height: 200px;"></div>
                    </b-col>

                </div>
            </div>
        </div>

        <div class="col-md-6 mt-2">
            <div class="card shadow-sm zakat p-1 h-100">
                <div class="card-header text-center bg-primary text-white rounded-3 mt-2">
                    <h6 class="card-title mb-0 fw-bold">{{$t("Last Zakat Info")}}</h6>
                </div>
                <div class="card-body fw-bold text-secondary">
                    <div class="row">
                        <div class="col-md-4 text-center mb-md-0">
                            <div class="zakat-info-item">
                                <h6 class="zakat-label">{{$t("Total Assets")}}:</h6>
                                <p class="zakat-data">{{getZakatData.currencyCode && getZakatData.totalAsset ?
                                    getZakatData.currencyCode +': '+getZakatData.totalAsset: 'No Data Found!'}}</p>
                            </div>
                        </div>
                        <div class="col-md-4 text-center mb-md-0">
                            <div class="zakat-info-item">
                                <h6 class="zakat-label">{{$t("Zakat Payable Amount")}}:</h6>
                                <p class="zakat-data">{{ getZakatData && getZakatData.currencyCode &&
                                    getZakatData.zakatAmount
                                    ? getZakatData.currencyCode + ': ' + getZakatData.zakatAmount
                                    : 'No Data Found'
                                    }}</p>
                            </div>
                        </div>
                        <div class="col-md-4 text-center mb-md-0">
                            <div class="zakat-info-item">
                                <h6 class="zakat-label">{{$t("Last Modify Date")}}:</h6>
                                <p class="zakat-data">{{lastCalculateFormatted && lastCalculateFormatted ?
                                    lastCalculateFormatted : 'No Data Found'}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Total Witness Card -->
        <div class="col-md-3 mt-2">
            <div class="card shadow-sm zakat h-100">
                <div class="card-body fw-bold text-secondary">
                    <div class="card-header bg-primary text-white rounded-3">
                        <h6 class="card-title mb-0 text-center fw-bold">{{$t("Total Witness")}}</h6>
                    </div>
                    <div class="content text-center mt-2">
                        <h6 class="zakat-label">{{$t("Witness")}}:</h6>
                        <p class="zakat-data">{{totalWitness}} {{$t("Persons")}}</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- Total Nominee Card -->
        <div class="col-md-3 mt-2">
            <div class="card shadow-sm zakat h-100">
                <div class="card-body fw-bold text-secondary">
                    <div class="card-header bg-primary text-white rounded-3">
                        <h6 class="card-title mb-0 text-center fw-bold">{{$t("Total Nominee")}}</h6>
                    </div>
                    <div class="content text-center mt-2">
                        <h6 class="zakat-label">{{$t("Nominee")}}:</h6>
                        <p class="zakat-data">{{totalNominee}} {{$t("Persons")}}</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- Last Wasiyyah Corrected Date Card 1 -->
        <div class="col-md-6 mt-2">
            <div class="card shadow-sm zakat p-2 h-100">
                <div class="card-header bg-primary text-white rounded-3 mt-2">
                    <h6 class="card-title mb-0 text-center fw-bold">{{$t("LAST WASIYYAH CORRECTED DATE")}}</h6>
                </div>
                <div class="card-body fw-bold text-secondary">
                    <div class="d-flex justify-content-between align-items-center mt-2">
                        <div class="date">
                            <h6>{{$t("Date")}}</h6>
                            <p class="mb-0">{{getModifyWasiyyahData.date}}</p>
                        </div>
                        <div class="time">
                            <h6>{{$t("Time")}}</h6>
                            <p class="mb-0">{{getModifyWasiyyahData.lastModifiedTime}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--  TODO: Start User Dashboard-->
</template>

<script>
    import Breadcrumb from '../partials/Breadcrumb.vue';
    import * as echarts from 'echarts';
    import apiRepository from "@/services/ApiRepository";
    import {toast} from 'vue3-toastify';
    import moment from "moment-hijri";
    import {mapActions, mapGetters} from 'vuex';

    export default {
        name: 'dashBoard',
        data() {
            return {
                lang: this.$store.state.lang,
                userRoles: [],
                retention: 'web',
                rawBreadcrumbs: [
                    {key: 'home', path: '/'},
                    {key: 'dashboard', path: '/dashboard'}
                ],
                filter: 'weekly',
                filterOptions: [
                    {text: this.$t('Weekly'), value: 'weekly'},
                    {text: this.$t('Monthly'), value: 'monthly'}
                ],
                filterUser: 'weekly',
                filterOptionsUser: [
                    {text: this.$t('Weekly'), value: 'weekly'},
                    {text: this.$t('Monthly'), value: 'monthly'}
                ],
                newUserData: 'weekly',
                retentionType: [
                    {text: this.$t('Web'), value: 'web'},
                    {text: this.$t('Phone'), value: 'phone'}
                ],
                countryData: 19,
                countryOptions: [],
                chart: null,
                RetentionRatePercentage: '',
                ReturningUserCount: '',
                TotalUserCount: '',
                adminActivityOptions: [],
                userActivityOptions: [],
                returningUserData: [],
                totalUserData: [],
                messageAll: [],
                allUserData: [],
                newUserOptionData: null,
                normalUserData: [],
                getZakatData: [],
                getModifyWasiyyahData: [],
                lastCalculateFormatted: null,
                newUserOption: [
                    {text: this.$t('Weekly'), value: 'weekly'},
                    {text: this.$t('Monthly'), value: 'monthly'}
                ],
                candidateIp: '',
                prayersData: {},
                city: '',
                prayersKeys: ['Fajr', 'Sunrise', 'Dhuhr', 'Asr', 'Maghrib', 'Isha'],
                englishDate: '',
                hijriDate: '',
                rawPrayerTimes: {},
                upcomingPrayer: null,
                timeUntilNext: "",
                upcomingPrayerInterval: null,
                totalNominee: null,
                totalWitness: null,

            }
        },
        mounted() {
            this.getTotalUserData();
            this.adminUserActivities(this.filter);
            this.allMessageGet();
            this.getReturningUser(this.newUserData, this.retention);
            this.getNewUser(this.newUserData, this.retention);
            this.getUserActivitiesData(this.filterUser);
            this.getCountryData();
            this.getZakatInfo();
            this.prayersTime();
            this.lasModifiedWasiyyahData();
            this.englishDate = moment().format("DD MMM, YYYY");
        },
        beforeUnmount() {
            if (this.countdownInterval) clearInterval(this.countdownInterval);
            if (this.upcomingPrayerInterval) clearInterval(this.upcomingPrayerInterval);
        },


        created() {
            this.decodeToken();
        },
        components: {
            Breadcrumb,
        },
        computed: {
            ...mapGetters(['isTestator', 'isAdmin', 'currentLang']),
            dateFormat() {
                const hijriMonthNames = [
                    "Muharram",
                    "Safar",
                    "Rabi al-Awwal",
                    "Rabi al-Thani",
                    "Jumada al-Awwal",
                    "Jumada al-Thani",
                    "Rajab",
                    "Sha'ban",
                    "Ramadan",
                    "Shawwal",
                    "Dhul Qadah",
                    "Dhul Hijjah"
                ];

                moment.locale('en');

                const m = moment();
                const day = m.iDate();
                const monthIndex = m.iMonth();
                const year = m.iYear();

                return `${day} ${hijriMonthNames[monthIndex]}, ${year}`;
            },
            dateFormatBn() {
                const hijriMonthNamesBn = [
                    "মুহাররম",
                    "সফর",
                    "রবিউল আউয়াল",
                    "রবিউস সানি",
                    "জমাদিউল আউয়াল",
                    "জমাদিউস সানি",
                    "রজব",
                    "শা‘বান",
                    "রমজান",
                    "শাওয়াল",
                    "জ্বিলকদ",
                    "জিলহজ"
                ];

                const toBanglaNumber = (num) => {
                    const engToBn = {
                        '0': '০', '1': '১', '2': '২', '3': '৩', '4': '৪',
                        '5': '৫', '6': '৬', '7': '৭', '8': '৮', '9': '৯'
                    };
                    return num.toString().split('').map(d => engToBn[d] || d).join('');
                };
                const locale = this.$store.state.lang;
                moment.locale(locale);
                const m = moment();

                const day = m.iDate();
                const monthIndex = m.iMonth();
                const year = m.iYear();

                return `${toBanglaNumber(day)} ${hijriMonthNamesBn[monthIndex]}, ${toBanglaNumber(year)}`;
            },
            breadcrumbs() {
                return this.rawBreadcrumbs.map(b => ({
                    text: this.$t(`breadcrumb.${b.key}`),
                    path: b.path
                }));
            },
            translatedPrayers() {
                return this.prayersKeys.map(k => this.$t(`prayers.${k}`));
            }

        },
        watch: {
            // retention(val) {
            //     this.getReturningUser(this.newUserData, val);
            // }
        },
        methods: {
            ...mapActions(["decodeToken"]),

            getBackgroundImage(key, upcomingPrayer) {
                if (key !== upcomingPrayer) return 'none';

                switch (key) {
                    case 'Fajr':
                        return 'url(/assets/images/fajr.png)';
                    case 'Dhuhr':
                        return 'url(/assets/images/dhuhr.png)';
                    case 'Asr':
                        return 'url(/assets/images/asr.png)';
                    case 'Maghrib':
                        return 'url(/assets/images/maghrib.png)'
                    case 'Isha':
                        return 'url(/assets/images/isha.png)';
                    default:
                        return 'none';
                }
            },
            getZakatInfo() {
                apiRepository.getZakatInfoData().then((res) => {
                    this.getZakatData = res.data;
                    const data = this.getZakatData.lastCalculate;
                    if (data) {
                        this.lastCalculateFormatted = this.formatDateToDDMMMYYYY(data);
                    }

                });
                apiRepository.getNominee().then((res) => {
                    this.totalNominee = res.data.length;
                });
                apiRepository.getWitness().then((res) => {
                    this.totalWitness = res.data.length;
                })
            },
            formatDateToDDMMMYYYY(isoString) {
                const date = new Date(isoString);
                const day = String(date.getDate()).padStart(2, '0');
                const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                const month = monthNames[date.getMonth()];
                const year = date.getFullYear();
                return `${day}-${month}-${year}`;
            },
            getCountryData() {
                if (!this.isAdmin) {
                    console.error('You do not have permission to access this data!');
                    return;
                }
                try {
                    apiRepository.getCountry().then((res) => {
                        if (res.data) {
                            this.countryOptions = res.data;
                        }
                    })
                } catch (error) {
                    toast.error(error || 'Data Not Found!');
                }
            },

            getDayName() {
                const lang = this.$store.state.lang;
                const locale = lang === 'bn' ? 'bn-BD' : 'en-US';
                const today = new Date();
                return today.toLocaleDateString(locale, {weekday: "long"}); // Returns day name
            },
            getDayAndMonth() {
                const lang = this.$store.state.lang;
                const today = new Date();
                const locale = lang === 'bn' ? 'bn-BD' : 'en-US';
                const monthName = today.toLocaleString(locale, {month: 'long'});
                const day = today.toLocaleString(locale, {day: 'numeric'});
                return `${monthName} ${day}`;
            },

            getYear() {
                const lang = this.$store.state.lang;
                const locale = lang == 'bn' ? 'bn-BD' : 'en-US';
                const today = new Date();
                return today.toLocaleString(locale, {year: 'numeric'});
            },
            getTotalUserData() {
                if (!this.isAdmin) {
                    return;
                }
                try {
                    apiRepository.getTotalUser().then((response) => {
                        if (response) {
                            this.totalUserData = response.data;
                        } else {
                            toast.error('Data not found!')
                        }
                    })
                } catch (error) {
                    toast.error("Error fetching data:", error);
                }

            },
            adminUserActivities(data) {
                if (!this.isAdmin) {
                    return;
                }
                try {
                    apiRepository.getAdminUserActivity(data).then((response) => {
                        if (response) {
                            this.adminActivityOptions = response.data;
                            const processedData = this.processChartData(this.adminActivityOptions);
                            this.initChart(processedData);
                        } else {
                            toast.error('Data Not Found!')
                        }
                    });

                } catch (error) {
                    toast.error("Error fetching data:", error);
                }
            },

            allMessageGet() {
                if (!this.isAdmin) {
                    console.error('You do not have permission to access this data!');
                    return;
                }
                try {
                    apiRepository.getTotalMessage().then((response) => {
                        if (response) {
                            this.messageAll = response.data;
                        } else {
                            toast.error('No messages available!');
                        }
                    }).catch(error => {
                        toast.error('Error fetching messages', error);
                    });
                } catch (error) {
                    toast.error('Fetching Data Invalid!', error);
                }
            },

            handleNewUserChange(val) {
                this.newUserData = val;
                this.getNewUser(val, this.retention);
                this.getReturningUser(val, this.retention);
            },

            handleRetentionChange(val) {
                this.retention = val;
                this.getReturningUser(this.newUserData, val);
                this.getNewUser(this.newUserData, val);
            },

            getReturningUser(data, source) {
                if (!this.isAdmin) {
                    return;
                }
                try {
                    apiRepository.returningUser(data, source).then((response) => {
                        if (response) {
                            this.returningUserData = response.data;
                        }
                    })
                } catch (e) {
                    toast.error('Invalid Request !', e);
                }
            },
            getUserData() {
                try {
                    apiRepository.userDataGet().then((response) => {
                        if (response) {
                            this.allUserData = response.data;
                        } else {
                            toast.error('Data Not Found!');
                        }
                    })
                } catch (e) {
                    toast.error('Invalid Request !', e)
                }
            },
            getNewUser(data, source) {
                try {
                    apiRepository.newUser(data, source).then((response) => {
                        if (response) {
                            this.newUserOptionData = response.data;

                        } else {
                            toast.error('Data not found!');
                        }
                    })
                } catch (e) {
                    toast.error('Invalid Request !', e)
                }
            },
            getUserActivitiesData(data) {
                apiRepository.getUserActivities(data).then((response) => {
                    if (response) {
                        this.userActivityOptions = response.data;
                        const userProcessedData = this.userProcessChartData(this.userActivityOptions);
                        this.initUserChart(userProcessedData);
                    } else {
                        toast.error('Data Not Found!');
                    }
                })
            },

            processChartData(data) {
                const dayWiseCounts = {
                    Sat: 0,
                    Sun: 0,
                    Mon: 0,
                    Tue: 0,
                    Wed: 0,
                    Thu: 0,
                    Fri: 0,
                };

                // Group logins by day of the week
                data.forEach((entry) => {
                    const day = new Date(entry.USER_LOGIN_TIME).toLocaleString("en-US", {weekday: "short"});
                    if (dayWiseCounts[day] !== undefined) {
                        dayWiseCounts[day] += 1;
                    }
                });

                // Ensure data is valid
                return {
                    xAxisData: Object.keys(dayWiseCounts),
                    seriesData: Object.values(dayWiseCounts),
                };
            },
            userProcessChartData(data) {
                const dayWiseCounts = {
                    Sat: 0,
                    Sun: 0,
                    Mon: 0,
                    Tue: 0,
                    Wed: 0,
                    Thu: 0,
                    Fri: 0,
                };

                // Group logins by day of the week
                data.forEach((entry) => {
                    const day = new Date(entry.USER_LOGIN_TIME).toLocaleString("en-US", {weekday: "short"});
                    if (dayWiseCounts[day] !== undefined) {
                        dayWiseCounts[day] += 1;
                    }
                });

                // Ensure data is valid
                return {
                    xAxisData: Object.keys(dayWiseCounts),
                    seriesData: Object.values(dayWiseCounts),
                };
            },

            initChart(processedData) {
                if (!processedData || !processedData.xAxisData || !processedData.seriesData) {
                    toast.error('Invalid data for chart:', processedData);
                    return;
                }

                const chartDom = this.$refs.chartContainer;
                if (!chartDom) {
                    toast.error('Chart container not found.');
                    return;
                }

                try {
                    this.chart = echarts.init(chartDom);

                    const options = {
                        title: {
                            textStyle: {
                                fontSize: 16,
                                fontWeight: "bold",
                            },
                        },
                        tooltip: {
                            trigger: "axis",
                            axisPointer: {
                                type: "cross",
                                label: {show: true}
                            },
                            formatter: (params) => {
                                const p = params[0];
                                return `${p.axisValue}<br/>Value: <b>${p.data}</b>`;
                            }
                        },
                        grid: {
                            left: "3%",
                            right: "3%",
                            bottom: "3%",
                            containLabel: true,
                        },
                        xAxis: {
                            type: "category",
                            data: processedData.xAxisData,
                            axisLabel: {
                                color: "#666",
                            },
                        },
                        yAxis: {
                            type: "value",
                            axisLabel: {
                                color: "#666",
                            },
                        },
                        series: [
                            {
                                data: processedData.seriesData,
                                type: "line",
                                smooth: true,
                                lineStyle: {
                                    color: "#3b82f6",
                                    width: 3,
                                },
                                areaStyle: {
                                    color: {
                                        type: "linear",
                                        x: 0,
                                        y: 0,
                                        x2: 0,
                                        y2: 1,
                                        colorStops: [
                                            {offset: 0, color: "rgba(59, 130, 246, 0.5)"},
                                            {offset: 1, color: "rgba(59, 130, 246, 0)"},
                                        ],
                                    },
                                },
                                symbol: "circle",
                                symbolSize: 8,
                                itemStyle: {
                                    color: "#ffffff",
                                    borderColor: "#3b82f6",
                                    borderWidth: 2,
                                },
                                emphasis: {
                                    focus: "series",
                                    label: {
                                        show: true,
                                        position: "top",
                                        formatter: "{c}",
                                        fontWeight: "bold",
                                        color: "#3b82f6",
                                    },
                                },
                            },
                        ],
                    };

                    this.chart.setOption(options);
                } catch (error) {
                    toast.error("Error initializing chart:", error);
                }
            },

            initUserChart(userProcessedData) {
                if (!userProcessedData || !userProcessedData.xAxisData || !userProcessedData.seriesData) {
                    toast.error('Invalid data for chart:', userProcessedData);
                    return;
                }

                const chartDom = this.$refs.chartUserContainer;
                if (!chartDom) {
                    toast.error('Chart container not found.');
                    return;
                }

                try {
                    this.chart = echarts.init(chartDom);

                    const options = {
                        title: {
                            textStyle: {
                                fontSize: 16,
                                fontWeight: "bold",
                            },
                        },
                        tooltip: {
                            trigger: "axis",
                            axisPointer: {
                                type: "cross",
                                label: {
                                    show: true
                                }
                            },
                            formatter: (params) => {
                                const p = params[0];
                                return `${p.axisValue}<br/>Users: <b>${p.data}</b>`;
                            }
                        },
                        grid: {
                            left: "3%",
                            right: "3%",
                            bottom: "3%",
                            containLabel: true,
                        },
                        xAxis: {
                            type: "category",
                            data: userProcessedData.xAxisData,
                            axisLabel: {
                                color: "#666",
                            },
                        },
                        yAxis: {
                            type: "value",
                            axisLabel: {
                                color: "#666",
                            },
                        },
                        series: [
                            {
                                data: userProcessedData.seriesData,
                                type: "line",
                                smooth: true,
                                lineStyle: {
                                    color: "#3b82f6",
                                    width: 3,
                                },
                                areaStyle: {
                                    color: {
                                        type: "linear",
                                        x: 0,
                                        y: 0,
                                        x2: 0,
                                        y2: 1,
                                        colorStops: [
                                            {offset: 0, color: "rgba(59, 130, 246, 0.5)"},
                                            {offset: 1, color: "rgba(59, 130, 246, 0)"},
                                        ],
                                    },
                                },
                                symbol: "circle",
                                symbolSize: 8,
                                itemStyle: {
                                    color: "#ffffff",
                                    borderColor: "#3b82f6",
                                    borderWidth: 2,
                                },
                                emphasis: {
                                    focus: "series",
                                    label: {
                                        show: true,
                                        formatter: '{c}',
                                        position: 'top',
                                        fontWeight: 'bold',
                                        color: '#3b82f6'
                                    }
                                }
                            },
                        ],
                    };

                    this.chart.setOption(options);
                } catch (error) {
                    toast.error("Error initializing chart:", error);
                }
            },

            prayersTime() {
                const cacheKey = 'prayerDataCache';
                const cache = JSON.parse(localStorage.getItem(cacheKey));
                const now = new Date();

                // If cache exists and is still valid (e.g., within 12 hours)
                if (cache && new Date(cache.expiry) > now) {
                    this.usePrayerData(cache.data);
                } else {
                    fetch("https://api.ipify.org?format=json")
                        .then(res => res.json())
                        .then(data => apiRepository.getPrayersTime(data.ip))
                        .then(res => {
                            const prayerData = {
                                city: res.data.city,
                                prayerInfo: res.data.prayerInfo
                            };

                            localStorage.setItem(cacheKey, JSON.stringify({
                                data: prayerData,
                                expiry: new Date(now.getTime() + 12 * 60 * 60 * 1000)
                            }));

                            this.usePrayerData(prayerData);
                        });
                }
            },
            usePrayerData(data) {
                this.city = data.city;
                const prayerInfo = data.prayerInfo;
                const formatted = {};
                const rawTimes = {};

                this.prayersKeys.forEach(key => {
                    const rawTime = prayerInfo[key];
                    rawTimes[key] = rawTime;
                    formatted[key] = moment(rawTime, "HH:mm").format("hh:mm A");
                });

                this.prayersData = formatted;
                this.rawPrayerTimes = rawTimes;
                this.findUpcomingPrayer();

                if (this.upcomingPrayerInterval) clearInterval(this.upcomingPrayerInterval);
                this.upcomingPrayerInterval = setInterval(() => {
                    this.findUpcomingPrayer();
                }, 60000);
            },


            findUpcomingPrayer() {
                const now = moment();
                const prayerKeys = ["Fajr", "Dhuhr", "Asr", "Maghrib", "Isha"];

                let upcomingKey = null;
                let upcomingTime = null;

                for (let key of prayerKeys) {
                    let time = moment(this.rawPrayerTimes[key], "HH:mm").set({
                        year: now.year(),
                        month: now.month(),
                        date: now.date()
                    });

                    if (time.isBefore(now)) {
                        time.add(1, 'day'); // Move to tomorrow if time passed
                    }

                    if (!upcomingTime || time.isBefore(upcomingTime)) {
                        upcomingTime = time;
                        upcomingKey = key;
                    }
                }

                this.upcomingPrayer = upcomingKey;

                if (this.countdownInterval) {
                    clearInterval(this.countdownInterval);
                }
                this.countdownInterval = setInterval(() => {
                    const now = moment();
                    const diff = moment.duration(upcomingTime.diff(now));

                    const hours = String(Math.floor(diff.asHours())).padStart(2, '0');
                    const minutes = String(diff.minutes()).padStart(2, '0');
                    const seconds = String(diff.seconds()).padStart(2, '0');

                    if (diff.asSeconds() <= 0) {
                        this.timeUntilNext = 'now';
                        clearInterval(this.countdownInterval);
                        this.findUpcomingPrayer(); // Refresh for next prayer
                    } else {
                        this.timeUntilNext = `${hours}:${minutes}:${seconds}`;
                    }
                }, 1000);
            },
            lasModifiedWasiyyahData() {
                apiRepository.lasModifiedWasiyyah().then((res) => {
                    this.getModifyWasiyyahData = res.data;
                    const rawDate = res.data.lastModifiedDate;
                    const date = new Date(rawDate);

                    const options = { day: '2-digit', month: 'long', year: 'numeric' };
                    const formattedDate = date.toLocaleDateString('en-GB', options).replace(/ /g, '-');

                    this.getModifyWasiyyahData.date = formattedDate;

                })
            },


        }

    };
</script>

<style scoped>
    .countryData {
        background: #cccdcf;
    }

    h2 {
        color: #3f51b5;
    }

    #filter_data {
        background-color: #DAE9EA !important;
        border-color: #DAE9EA !important;
        color: #000;
    }

    #filter_data:focus {
        box-shadow: none;
        border-color: #DAE9EA;
    }
</style>
